export enum RecodeConditionType {
    TARIFF = 'TARIFF',
    FREE = 'FREE',
    AMOUNT = 'AMOUNT',
    TIME = 'TIME',
    OPERATOR_SELECTABLE = 'OPERATOR_SELECTABLE',
}

export enum CloudConnectorRecodeConditionType {
    DEVICE_ONLY = 'DEVICE_ONLY',
    QR_AND_DEVICE = 'QR_AND_DEVICE',
    QR_SELECTABLE_AMOUNT = 'QR_SELECTABLE_AMOUNT',
    QR_SELECTABLE_TIME = 'QR_SELECTABLE_TIME',
}

export function cloudConnectorRecodeConditionAllowsQr(
    conditionType: CloudConnectorRecodeConditionType,
): boolean {
    switch (conditionType) {
        case CloudConnectorRecodeConditionType.DEVICE_ONLY:
            return false;
        case CloudConnectorRecodeConditionType.QR_AND_DEVICE:
        case CloudConnectorRecodeConditionType.QR_SELECTABLE_AMOUNT:
        case CloudConnectorRecodeConditionType.QR_SELECTABLE_TIME:
            return true;
    }
}
